import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'employeeFormat',
    pure: false,
    standalone: false
})

export class EmployeeFormatPipe implements PipeTransform {
  transform(value: string, args?: any[]): any {
    return value.replace(/;/g, ' ');
  }
}
